import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Row, Col, Modal, message, Table, Tag, Alert } from "antd";
import { TableItem, ButtonItem, InputNumberItem } from "../../../Components/Items";
import DatePickerItem from "../../../Components/DatePickerItem";

// Mismas funciones puras que VacacionesEmpleado.js — duplicadas aquí solo para el
// preview client-side; el cálculo oficial que se persiste lo hace el backend.
function calcularDiasHabiles(inicio, fin) {
  if (!inicio || !fin) return 0;
  let count = 0;
  const current = new Date(inicio + "T12:00:00");
  const end = new Date(fin + "T12:00:00");
  while (current <= end) {
    if (current.getDay() !== 0) count++;
    current.setDate(current.getDate() + 1);
  }
  return count;
}

function calcularSeptimos(inicio, fin) {
  if (!inicio || !fin) return 0;
  let count = 0;
  const current = new Date(inicio + "T12:00:00");
  const end = new Date(fin + "T12:00:00");
  while (current <= end) {
    if (current.getDay() === 0) count++;
    current.setDate(current.getDate() + 1);
  }
  return count;
}

const labelStyle = { display: "block", fontSize: 11, color: "#888", marginBottom: 3 };
const selectStyle = {
  width: "100%", padding: "4px 8px", border: "1px solid #d0d0d0",
  borderRadius: 4, fontSize: 12, height: 28, background: "white", cursor: "pointer",
  boxSizing: "border-box",
};

class VacacionesMasivas extends Component {
  state = {
    cargando: false,
    empleados: [],
    seleccionados: [],
    tipo: "vacaciones_y_prima",
    fechaInicio: "",
    fechaFin: "",
    fechaPago: "",
    factorPrima: 0.25,
    aplicando: false,
    resultado: null,
  };

  componentDidMount() {
    this.cargarEmpleados();
  }

  cargarEmpleados() {
    this.setState({ cargando: true });
    axios
      .post(
        "empleados/selectTodosEmpleados",
        { empresaId: this.props.empresaId, valor: 1 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ cargando: false, empleados: Array.isArray(res.data) ? res.data : [] });
      })
      .catch(() => {
        this.setState({ cargando: false });
        message.error("Error al cargar los empleados");
      });
  }

  confirmarAplicar = () => {
    const { seleccionados, tipo, fechaInicio, fechaFin, fechaPago } = this.state;

    if (!seleccionados.length) {
      message.info("Selecciona al menos un empleado");
      return;
    }
    if (!fechaPago) {
      message.error("Ingresa la fecha de pago");
      return;
    }
    if (tipo !== "solo_prima" && (!fechaInicio || !fechaFin)) {
      message.error("Ingresa fecha inicial y final");
      return;
    }

    Modal.confirm({
      title: "Aplicar vacaciones masivas",
      content: (
        <div>
          <p>
            Se aplicará este movimiento a <b>{seleccionados.length}</b> empleado(s).
          </p>
          <p style={{ color: "#A32D2D" }}>
            Si algún empleado no tiene suficientes días disponibles, el movimiento se
            aplicará de todas formas y su kárdex quedará en saldo negativo (adelanto
            de vacaciones). Esta operación no se puede deshacer masivamente — solo
            cancelando movimientos uno por uno.
          </p>
        </div>
      ),
      okText: "Sí, aplicar",
      cancelText: "Cancelar",
      onOk: () => this.aplicarMasivo(),
    });
  };

  async aplicarMasivo() {
    const { empresaId, headersToken } = this.props;
    const { seleccionados, tipo, fechaInicio, fechaFin, fechaPago, factorPrima } = this.state;

    this.setState({ aplicando: true, resultado: null });
    try {
      const res = await axios.post(
        "nomina/aplicarVacacionesMasivas",
        {
          empresaId,
          empleadoIds: seleccionados,
          periodoId: null,
          tipo, fechaInicio, fechaFin, fechaPago,
          factorPrima,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success(
          `Aplicado a ${res.data.exitosos} de ${res.data.total} empleado(s)` +
          (res.data.negativos ? ` — ${res.data.negativos} con saldo negativo` : "")
        );
        this.setState({ resultado: res.data, seleccionados: [] });
      } else {
        message.error(res.data.mensaje || "No se pudo aplicar el movimiento masivo");
      }
    } catch {
      message.error("Error de conexión al aplicar vacaciones masivas");
    }
    this.setState({ aplicando: false });
  }

  render() {
    const {
      cargando, empleados, seleccionados,
      tipo, fechaInicio, fechaFin, fechaPago, factorPrima,
      aplicando, resultado,
    } = this.state;

    const diasVacaciones = tipo === "solo_prima" ? 0 : calcularDiasHabiles(fechaInicio, fechaFin);
    const diasSeptimos   = tipo === "solo_prima" ? 0 : calcularSeptimos(fechaInicio, fechaFin);
    const diasPrima      = tipo === "solo_prima" ? 0 : diasVacaciones;
    const deshabilitarFechas = tipo === "solo_prima";

    const columns = [
      { title: "No.", dataIndex: "serieNumero", key: "serieNumero", width: 90 },
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Departamento", dataIndex: "departamento", key: "departamento" },
      { title: "Puesto", dataIndex: "puesto", key: "puesto" },
    ];

    const columnsResultado = [
      { title: "Empleado", dataIndex: "nombre", key: "nombre" },
      {
        title: "Estatus", dataIndex: "ok", key: "ok",
        render: (ok, row) => ok
          ? <Tag color="green">Aplicado</Tag>
          : <Tag color="red">{row.mensaje || "Error"}</Tag>,
      },
      {
        title: "Saldo resultante", dataIndex: "saldoResultante", key: "saldoResultante",
        render: (v) => v == null ? "—" : (
          <span style={{ color: v < 0 ? "#A32D2D" : "inherit", fontWeight: v < 0 ? 600 : 400 }}>{v}</span>
        ),
      },
    ];

    return (
      <div>
        <Row gutter={10}>
          <Col xs={24} md={10}>
            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>Tipo de captura</label>
              <select
                value={tipo}
                onChange={(e) => this.setState({ tipo: e.target.value })}
                style={selectStyle}
              >
                <option value="vacaciones_y_prima">Vacaciones y prima vacacional</option>
                <option value="solo_vacaciones">Solo vacaciones</option>
              </select>
            </div>

            <Row gutter={8} style={{ marginBottom: 12 }}>
              <Col span={8}>
                <label style={labelStyle}>Fecha inicial</label>
                <DatePickerItem
                  value={fechaInicio ? moment(fechaInicio, "YYYY-MM-DD") : null}
                  disabled={deshabilitarFechas}
                  onChange={(d) => this.setState({ fechaInicio: d ? d.format("YYYY-MM-DD") : "" })}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>
                <label style={labelStyle}>Fecha final</label>
                <DatePickerItem
                  value={fechaFin ? moment(fechaFin, "YYYY-MM-DD") : null}
                  disabled={deshabilitarFechas}
                  onChange={(d) => this.setState({ fechaFin: d ? d.format("YYYY-MM-DD") : "" })}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>
                <label style={labelStyle}>Fecha de pago</label>
                <DatePickerItem
                  value={fechaPago ? moment(fechaPago, "YYYY-MM-DD") : null}
                  onChange={(d) => this.setState({ fechaPago: d ? d.format("YYYY-MM-DD") : "" })}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <Row gutter={8} style={{ marginBottom: 12 }}>
              <Col span={8}>
                <label style={labelStyle}>Días de vacaciones</label>
                <input type="number" readOnly value={diasVacaciones}
                  style={{ width: "100%", padding: "4px 8px", border: "1px solid #d0d0d0", borderRadius: 4, background: "#f5f5f5", color: "#1677ff", fontWeight: 600, boxSizing: "border-box" }} />
              </Col>
              <Col span={8}>
                <label style={labelStyle}>Séptimos</label>
                <input type="number" readOnly value={diasSeptimos}
                  style={{ width: "100%", padding: "4px 8px", border: "1px solid #d0d0d0", borderRadius: 4, background: "#f5f5f5", color: "#1677ff", fontWeight: 600, boxSizing: "border-box" }} />
              </Col>
              <Col span={8}>
                <label style={labelStyle}>Factor prima</label>
                <InputNumberItem
                  value={factorPrima}
                  min={0} max={1} step={0.05}
                  onChange={(v) => this.setState({ factorPrima: v ?? 0.25 })}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>

            {/* Los días de descanso del rango NO se pagan como vacaciones: los paga el concepto
                Séptimo Día, íntegro. Sólo los hábiles bajan del kárdex. */}
            <Alert
              type="info"
              showIcon
              message={`Días de prima a aplicar por empleado: ${diasPrima}`}
              description={deshabilitarFechas ? undefined
                : `La nómina pagará Vacaciones ${diasVacaciones} + Séptimo día ${diasSeptimos} = ${diasVacaciones + diasSeptimos} días del periodo. Al kárdex se le descuentan los ${diasVacaciones} días de vacaciones.`}
              style={{ marginBottom: 12, fontSize: 12 }}
            />

            <ButtonItem
              type="primary"
              block
              loading={aplicando}
              disabled={!seleccionados.length}
              onClick={this.confirmarAplicar}
            >
              Aplicar a {seleccionados.length} empleado(s) seleccionado(s)
            </ButtonItem>
          </Col>

          <Col xs={24} md={14}>
            <TableItem
              rowKey={(v) => v._id}
              columns={columns}
              dataSource={empleados}
              loading={cargando}
              size="small"
              rowSelection={{
                selectedRowKeys: seleccionados,
                onChange: (keys) => this.setState({ seleccionados: keys }),
              }}
              defaultPageSize={8}
            />
          </Col>
        </Row>

        {resultado && (
          <div style={{ marginTop: 16 }}>
            <h4>
              Resultado: {resultado.exitosos} de {resultado.total} aplicados
              {resultado.negativos ? ` — ${resultado.negativos} con saldo negativo` : ""}
            </h4>
            <Table
              rowKey={(v) => v.empleadoId}
              columns={columnsResultado}
              dataSource={resultado.detalle}
              size="small"
              pagination={{ pageSize: 8 }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VacacionesMasivas);
